import React from 'react';
import { Navigate } from 'react-router-dom';
import { Database } from '../../server/database';
import { Server } from '../../server/server';
import { AppConfig } from '../AppConfig';
import PurchaseAssetModal from '../modals/PurchaseAssetModal';
import SellTokensModal from '../modals/SellTokensModal';
import './WalletPage.css';

interface WalletPageState {
  openPurchaseAsset: boolean;
  openSellTokens: boolean;
}

class WalletPage extends React.Component<{}, WalletPageState> {
  constructor(props = {}) {
    super(props);

    this.state = {
      openPurchaseAsset: false,
      openSellTokens: false
    }

    this.onOpenPurchaseAsset = this.onOpenPurchaseAsset.bind(this);
    this.onClosePurchaseAsset = this.onClosePurchaseAsset.bind(this);
    this.onOpenSellTokens = this.onOpenSellTokens.bind(this);
    this.onCloseSellTokens = this.onCloseSellTokens.bind(this);
  }

  onOpenPurchaseAsset() {
    this.setState({openPurchaseAsset: true});
  }

  onClosePurchaseAsset() {
    this.setState({openPurchaseAsset: false});
  }

  onOpenSellTokens() {
    this.setState({openSellTokens: true});
  }

  onCloseSellTokens() {
    this.setState({openSellTokens: false});
  }

  render() {
    if(!Server.account.isLoggedIn())
      return <Navigate to="/" replace />;

    let tokenAsset = Database.getAsset(AppConfig.token.id);
    let tokenSymbol = AppConfig.token.symbol;
      
    return (
      <div className="wallet-page">
        <div className="wallet-page-container">
          <img className="wallet-forte-logo" src="forte.png"></img>
          <div className="wallet-page-intro">
            <div>
              The <span style={{color:'white'}}>{tokenAsset.name}</span> ({tokenSymbol}) is a crypto-currency backed by the <a style={{color:'white'}} href="https://www.forte.io" target="_blank">Forte Blockchain</a>.  Your account comes with a Forte Wallet to store your tokens. 
            </div>
          </div>
          <div className="wallet-section">
            <div className="wallet-section-header">
              Conversion Rates
            </div>
            <div className="wallet-section-row" style={{height: '32px'}}>
              <div>USD/{tokenSymbol}</div>
              <div style={{textAlign: 'right', marginRight: '8px'}}>$0.01</div>
              <div>USD</div>
            </div>
            {AppConfig.coin.enabled &&
              <div className="wallet-section-row">
                <div>Coins/{tokenSymbol}</div>
                <div style={{textAlign: 'right', marginRight: '8px'}}>10</div>
                <div><img style={{width:'32px', marginTop: '4px'}} src="/assets/coin.png"></img></div>
              </div>
            }
          </div>
          <div className="wallet-section">
            <div className="wallet-section-header">Your Forte Wallet</div>
            <div className="wallet-section-row">
              <div>Balance</div>
              <div style={{textAlign: 'right', marginRight: '8px'}}>{Server.user.getTokenCount()}</div>
              <div><img style={{width:'32px', marginTop: '4px'}} src={'/assets/' + AppConfig.token.id + '.png'}></img></div>
            </div>
            <div className="wallet-section-row">
              <div>Value</div>
              <div style={{textAlign: 'right', marginRight: '8px'}}>${(Server.user.getTokenCount() * 0.01).toFixed(2)}</div>
              <div>USD</div>
            </div>
          </div>
          <div className="wallet-section-buttons">
            <button onClick={this.onOpenSellTokens}>Sell {tokenSymbol}</button>
            <button onClick={this.onOpenPurchaseAsset}>Purchase {tokenSymbol}</button>
          </div>
        </div>

        <PurchaseAssetModal 
          show={this.state.openPurchaseAsset} 
          asset={AppConfig.token.id}
          onPurchase={this.onClosePurchaseAsset} 
          onCancel={this.onClosePurchaseAsset} 
        />
        <SellTokensModal open={this.state.openSellTokens} onClose={this.onCloseSellTokens} />
      </div>
    );
  }
}

export default WalletPage;